import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeading, waLink } from "./shared";
import { SERVICES } from "../../data/services";

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-24 sm:py-32 bg-navy/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Core Services — 04 Chapters"
        title="Practical support for the tech"
        accent="you use every day."
        sub="Choose the service closest to your issue. Not sure which one applies? Send AFZ a message and describe the symptoms."
      />
      <Reveal delay={0.1}>
        <div className="mt-12 relative clip-corner border border-brand-cyan/30 overflow-hidden sm:max-h-72 shadow-[0_0_40px_rgba(34,211,238,0.1)]">
          <img
            src="/assets/collateral-repair.jpg"
            alt="AFZ laptop and desktop repair — diagnose, repair, upgrade"
            className="w-full h-auto object-contain sm:h-72 sm:object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-void/70 via-transparent to-void/40" />
        </div>
      </Reveal>
      <div className="mt-16 space-y-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.08}>
            <div
              data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative bg-card/80 border border-slate-800 rounded-2xl p-6 sm:p-8 grid md:grid-cols-[auto_1fr_auto] gap-6 items-center hover:border-brand-lime/50 transition-all duration-300 hover:shadow-[0_0_35px_rgba(170,255,0,0.12)] overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-brand-lime to-brand-cyan opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="flex items-center gap-6">
                <span className="font-display text-5xl sm:text-6xl font-black text-white/10 group-hover:text-brand-lime/30 transition-colors duration-300 leading-none">
                  {s.num}
                </span>
                <div className="w-14 h-14 rounded-full border-2 border-brand-lime/60 bg-brand-lime/10 flex items-center justify-center text-brand-lime shadow-[0_0_20px_rgba(170,255,0,0.25)] transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_28px_rgba(170,255,0,0.5)]">
                  <s.icon className="w-6 h-6" />
                </div>
              </div>
              <div>
                <h3 className="font-display text-2xl sm:text-3xl font-bold uppercase text-white tracking-wide">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm sm:text-base text-slate-400 leading-relaxed max-w-2xl">{s.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span key={t} className="font-mono text-[10px] uppercase tracking-[0.15em] text-brand-cyan border border-brand-cyan/30 rounded-full px-3 py-1">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex md:flex-col items-center md:items-end gap-4 md:gap-3">
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">{s.eta}</span>
                <Link
                  data-testid={`service-details-${s.slug}`}
                  to={`/services/${s.slug}`}
                  className="inline-flex items-center gap-2 text-slate-300 font-mono text-[11px] uppercase tracking-[0.15em] hover:text-brand-lime transition-colors duration-300"
                >
                  View Details <ArrowUpRight className="w-3.5 h-3.5" />
                </Link>
                <a
                  data-testid={`service-book-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                  href={waLink(`Hi AFZ Tech Solution, I need help with: ${s.title}.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 border border-brand-lime/50 text-brand-lime font-display font-bold uppercase text-sm px-5 py-2.5 rounded-full hover:bg-brand-lime hover:text-void transition-all duration-300"
                >
                  Book Repair <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
